// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { FileKind } from "../../../../define/FileKind";
import { GeneralKind } from "../../../../define/GeneralKind";
import { SettleLawsuitKind } from "../../../../define/SettleLawsuitKind";
import SettleLawsuitLayer from "../common/SettleLawsuitLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettleLawsuitMainLayer extends SettleLawsuitLayer {

    @property(cc.Prefab)
    prefabDetail: cc.Prefab = null;
    @property(cc.Prefab)
    prefabSelect: cc.Prefab = null;
    @property(cc.Prefab)
    prefabSelectSuspects: cc.Prefab = null;

    private csvInfo: any = null;
    /** 性别 */
    // private sexType: string = null;
    /** 五官数据 */
    // private featuresData = {};
    /** 描述数据 */
    private strDesc = '';

    /** 五官数据组 */
    private featuresArrData = {};

    start () {
        this.initLayer();
    }

    initLayer() {
        let id = this._carryData.id;
        this.csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.LEGAL_CASE_MAIN, id);
        if (!this.csvInfo) {
            console.error(`数据获取失败`);
            return;
        }

        this.initData();

        this.resetData();
    }

    initData() {
        // 性别
        let sexType = this.csvInfo.sex;
        this.strDesc = this.csvInfo.value;

        let bHair = this.csvInfo.is_hair == GeneralKind.EnableState.ENABLED;
        let FeaturesType = SettleLawsuitKind.FeaturesType;
        let csvInfo = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.LEGAL_CASE_MAIN_ATTRIBUTE);
        let title = csvInfo.title;
        for (let i in FeaturesType) {
            if (!isNaN(Number(i))) {
                continue;
            }

            let typeId = FeaturesType[i];
            let infoArr = csvInfo[typeId];
            if (!infoArr) {
                console.error(`未找到属性 typeid = ${typeId}`);
                return;
            }
            let retArr: any[] = [];
            for (let o of infoArr) {
                let bAdd = false;
                if (sexType == SettleLawsuitKind.SexType.MEN) {
                    if (o[title.use_men] == GeneralKind.EnableState.ENABLED) {
                        bAdd = true;
                    }
                } else {
                    if (o[title.use_women] == GeneralKind.EnableState.ENABLED) {
                        bAdd = true;
                    }
                }
                if (bAdd) {
                    if (FeaturesType[i] == FeaturesType.FEATURE) {
                        if (o[title.is_hair] == GeneralKind.EnableState.ENABLED) {
                            if (!bHair) {
                                bAdd = false;
                            }
                        } else {
                            if (bHair) {
                                bAdd = false;
                            } 
                        }
                    } 
                }
                if (bAdd) {
                    retArr.push(o);
                }
            }

            this.featuresArrData[typeId] = retArr;
        }
    }

    resetData() {
        this.openDetailLayer();
    }

    openDetailLayer() {
        let node = cc.instantiate(this.prefabDetail);
        let detailScript = node.getComponent(BasePopUpLayer);
        detailScript.setCarryData({
            parent: this
            , desc: this.strDesc
        });
        this.node.addChild(node);
    }

    onClickSelect() {
        let node = cc.instantiate(this.prefabSelect);
        let script = node.getComponent(BasePopUpLayer);
        script.setCarryData({
            parent: this
            , csvInfo: this.csvInfo
            , featuresArrData: this.featuresArrData
        });
        this.node.addChild(node);
    }

    onClickselelctSuspects(featuresArrIndex: any) {
        let node = cc.instantiate(this.prefabSelectSuspects);
        let script = node.getComponent(BasePopUpLayer);
        script.setCarryData({
            parent: this
            , csvInfo: this.csvInfo
            , featuresArrIndex: featuresArrIndex
            , featuresArrData: this.featuresArrData
        });
        this.node.addChild(node);
    }

    showResultUI(bWin: boolean) {
        if (bWin) {
            let award = this.csvInfo.success;
            let retArr = utilsModel.splitLineFeed(award);
            this.openSuccessLayer(
                retArr
                , FileKind.PrefabFilePath.SettleLawsuitMainSuccessLayer
                , {
                    bHighScore: false
                }
            );
        } else {
            let award = this.csvInfo.lose;
            let retArr = utilsModel.splitLineFeed(award);
            this.openLoseLayer(retArr, FileKind.PrefabFilePath.SettleLawsuitMainLoseLayer);
        }
    }

    // update (dt) {}
}
